export default __webpack_public_path__ + "static/media/panelData2.7bdd7a87.png";